import { createFileRoute } from "@tanstack/react-router";
import { Box, Spinner } from "@salestrak/ui";
import { useApiKeys, useApiKeyMutations } from "#app/hooks/settings/use-api-key-mutations";
import { useAppData } from "#app/lib/data";
import { ApiKeyDetailView } from "#app/components/settings/api-key-detail-view";
import { ApiKeyRevokeDialog } from "#app/components/settings/api-key-revoke-dialog";
import { useState } from "react";
import { useAppNavigate } from "#app/lib/hooks/use-app-navigate";

function AccessDetailPage() {
  const { apiKeyId } = Route.useParams();
  const { push, replace } = useAppNavigate();
  const { currentUser } = useAppData();
  const { apiKeys, isLoading } = useApiKeys(currentUser?.userId);
  const { revokeApiKey } = useApiKeyMutations();

  const [showRevoke, setShowRevoke] = useState(false);

  const apiKey = apiKeys.find((k: any) => k.apiKeyId === apiKeyId);

  if (isLoading && !apiKey) {
    return (
      <Box fill="flex" align="center" justify="center">
        <Spinner />
      </Box>
    );
  }

  if (!apiKey) {
    replace("/settings/access");
    return null;
  }

  async function handleRevoke() {
    await revokeApiKey(apiKeyId);
    replace("/settings/access");
  }

  return (
    <>
      <ApiKeyDetailView
        apiKey={apiKey}
        onBack={() => replace("/settings/access")}
        onEdit={() =>
          push(`/settings/access/${apiKeyId}/edit`)
        }
        onRevoke={() => setShowRevoke(true)}
      />

      <ApiKeyRevokeDialog
        open={showRevoke}
        onOpenChange={(open) => { if (!open) setShowRevoke(false); }}
        apiKeyName={apiKey.name}
        onConfirm={handleRevoke}
      />
    </>
  );
}

export const Route = createFileRoute(
  "/(app)/$workspace/settings/access/$apiKeyId/",
)({ component: AccessDetailPage });
